/**
 * 工作流步骤定义 —— 前后端唯一真相。
 * 步骤顺序与进入门槛来自对标产品实测（详见 docs/05-逆向分析报告全文.md 第 4.3 节）。
 */
export const WORKFLOW_STEPS = [
    { key: 'topic', index: 1, label: '选题', title: '选一条值得做的话题', gateMessage: null, requires: null },
    {
        key: 'copywriting',
        index: 2,
        label: '文案',
        title: '把选题写成能念出来的口播稿',
        gateMessage: '请先选择一条选题',
        requires: 'topic',
    },
    {
        key: 'audio',
        index: 3,
        label: '配音',
        title: '用你的音色把文案读出来',
        gateMessage: '请先完成文案，再进入配音',
        requires: 'copywriting',
    },
    {
        key: 'digital-human',
        index: 4,
        label: '数字人',
        title: '让一个会说话的你出镜',
        gateMessage: '请先完成配音，再进入数字人',
        requires: 'audio',
    },
    {
        key: 'editing',
        index: 5,
        label: '剪辑',
        title: '自动剪掉气口、加字幕和音乐',
        gateMessage: '请先生成数字人视频，再进入风格剪辑',
        requires: 'digital-human',
    },
    {
        key: 'cover',
        index: 6,
        label: '标题封面',
        title: '写标题、出封面',
        gateMessage: '请先生成数字人视频，再进入封面',
        requires: 'digital-human',
    },
    {
        key: 'publish',
        index: 7,
        label: '发布',
        title: '确认无误，复制信息去发布',
        gateMessage: '请先生成封面，再进入发布',
        requires: 'cover',
    },
];
export function getStep(key) {
    const step = WORKFLOW_STEPS.find((item) => item.key === key);
    if (!step)
        throw new Error(`unknown workflow step: ${key}`);
    return step;
}
/** 是否允许进入某一步；返回 null 表示放行 */
export function checkStepGate(key, progress) {
    const step = getStep(key);
    if (!step.requires)
        return null;
    return progress[step.requires] ? null : step.gateMessage;
}
export function nextStepKey(key) {
    const step = getStep(key);
    const next = WORKFLOW_STEPS.find((item) => item.index === step.index + 1);
    return next ? next.key : null;
}
//# sourceMappingURL=workflow.js.map